import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { extendTailwindMerge, validators } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display-84",
            "display-60",
            "display-40",
            "data-108",
            "data-60",
            "data-40",
            "heading-60",
            "heading-48",
            "heading-40",
            "heading-36",
            "heading-32",
            "heading-28",
            "heading-24",
            "heading-20",
            "heading-18",
            "heading-16",
            "heading-12",
            "body-24",
            "body-20",
            "body-16",
            "body-14",
            "body-12",
            "body-xl",
            "body-lg",
            "body-md",
            "body",
            "body-sm",
            "body-xs",
            "body-2xs",
            "button-16",
            "button-14",
            "label-10",
            "label-12",
            "label-18",
            // Redesign — ds-* typography scale (DESIGN.md).
            "ds-display-lg",
            "ds-display-md",
            "ds-display-sm",
            "ds-heading-h1",
            "ds-heading-h2",
            "ds-heading-h3",
            "ds-heading-h4",
            "ds-heading-h5",
            "ds-body-lg",
            "ds-body-md",
            "ds-body-sm",
            "ds-body-xs",
            "ds-label-lg",
            "ds-label-md",
            "ds-label-sm",
            // Keep tailwind-merge's default font-size matchers — without
            // these, `text-base`/`text-sm`/`text-[10px]` fall into the
            // text-color group and get dropped when merged with a color.
            "base",
            validators.isTshirtSize,
            validators.isArbitraryLength,
          ],
        },
      ],
      // Redesign — ds-* stroke widths (DESIGN.md).
      "border-w": [
        { border: ["ds-default", "ds-medium", "ds-focus", "ds-lg"] },
      ],
      // Redesign — ds-* gradient tokens must live in the bg-image group so
      // `bg-ds-gradient-primary` correctly overrides `bg-ds-gradient-secondary`.
      "bg-image": [{ bg: ["ds-gradient-primary", "ds-gradient-secondary"] }],
    },
    theme: {
      radius: [
        "container",
        "3xl",
        "xl",
        "lg",
        "md",
        "sm",
        "xs",
        "ui-large-xxl",
        // Redesign — ds-* radius scale (DESIGN.md).
        "ds-none",
        "ds-xs",
        "ds-s",
        "ds-m",
        "ds-l",
        "ds-xl",
        "ds-xxl",
        "ds-full",
      ],
      shadow: [
        // Redesign — ds-* elevation tokens (DESIGN.md).
        "ds-xs",
        "ds-sm",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
